import type { Command, CommandGroup } from './command.types'

export function isCommandEnabled<Context>(
  command: Command<Context>,
  context: Context,
): boolean {
  return command.isEnabled?.(context) ?? true
}

export function isCommandVisible<Context>(
  command: Command<Context>,
  context: Context,
): boolean {
  return command.isVisible?.(context) ?? true
}

export function executeCommand<Context>(
  command: Command<Context>,
  context: Context,
): void {
  if (!isCommandVisible(command, context)) return
  if (!isCommandEnabled(command, context)) return

  command.execute(context)
}

export function getVisibleCommandGroups<Context>(
  groups: CommandGroup<Context>[],
  context: Context,
) {
  return groups
    .map((group) => ({
      ...group,
      commands: group.commands.filter((command) =>
        isCommandVisible(command, context),
      ),
    }))
    .filter((group) => group.commands.length > 0)
}
